import {
  As,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Icon,
  Switch,
  SwitchProps,
  VStack,
} from '@chakra-ui/react';
import { FC } from 'react';

export interface ToggleProps {
  status?: boolean;
  icon?: As;
  label?: string;
  header?: string;
  onChange?: SwitchProps['onChange'];
}

export const Toggle: FC<ToggleProps> = ({
  status = false,
  icon,
  header,
  label,
  onChange,
}) => (
  <VStack align="stretch">
    <HStack spacing={2}>
      {icon && <Icon as={icon} color="brand.monochromatic.700" />}
      {header && (
        <Heading
          fontSize="md"
          color="brand.monochromatic.700"
          fontWeight="normal"
        >
          {header}
        </Heading>
      )}
    </HStack>

    <FormControl
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <FormLabel
        className="wrapable"
        htmlFor="receive-donations-toggle"
        aria-label="receive-donations-toggle"
        color="brand.additional.black"
        fontWeight="500"
      >
        {label}
      </FormLabel>

      <Switch
        id="receive-donations-toggle"
        // TODO: update colorscheme values in St. Jude theme
        colorScheme="green"
        size="lg"
        defaultChecked={status}
        onChange={onChange}
      />
    </FormControl>
  </VStack>
);
